<template>
  <div dense class="LKPassportContextualData">
    <div class="LKPassportContextualData__left">
      <LKPassportContextualDataLeft :data="data" />
    </div>

    <div class="LKPassportContextualData__right">
      <LKPassportContextualDataRight
        :data="data"
        :readonly="readonly"
        :on-contexts-updated="onContextsUpdated"
        :on-contexts-submit="onContextsSubmit"
      />
    </div>
  </div>
</template>

<script>
import LKPassportContextualDataLeft from './LKPassportContextualDataLeft.vue'
import LKPassportContextualDataRight from './LKPassportContextualDataRight.vue'

export default {
  name: 'LKPassportContextualData',
  components: {
    LKPassportContextualDataLeft,
    LKPassportContextualDataRight,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    onContextsUpdated: {
      type: Function,
      required: true,
    },
    onContextsSubmit: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
  },
}
</script>

<style lang="scss">
.LKPassportContextualData {
  position: relative;
  display: flex;
  padding: 18px 22px 25px 22px;
  background-color: $webflow-color-blue-shadow;

  &__left {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  &__right {
    padding-left: 24px;
    margin-left: 24px;
    border-left: 1px solid $webflow-color-blue-light;
  }
}
</style>
